import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { LegacyButtonSize } from '../button-type';
import { buttonBaseStyle, buttonFocusStyle, baseButtonStyles } from '../common.styles';
import type { SecondaryButtonProps } from './types';

type StyleProps = Pick<SecondaryButtonProps, 'destructive' | 'size'>;

const secondaryButtonDefaultStyle = css`
  background: transparent;
  border: 1px solid ${theme.colors.neutral30};
  border-radius: ${theme.borderRadius.small};
  color: ${theme.font.colors.default};
  transition: background 250ms ease-out, border-color 250ms ease-out;

  &:hover,
  &:focus {
    background: ${theme.colors.neutral5};
    border-color: ${theme.colors.neutral5};
  }

  &:active {
    background: transparent;
    border-color: ${theme.colors.neutral90};
  }

  &:disabled {
    background: white;
    border-color: ${theme.colors.status.disabled};
    color: ${theme.colors.neutral20};
  }
`;

const secondaryButtonDestructiveStyle = css`
  color: ${theme.colors.status.critical};
`;

export const SecondaryButtonStyles = {
  secondaryButton: ({ size = 'large' as LegacyButtonSize, destructive }: StyleProps): string =>
    cx(
      buttonBaseStyle,
      buttonFocusStyle,
      baseButtonStyles[size],
      secondaryButtonDefaultStyle,
      destructive && secondaryButtonDestructiveStyle
    ),
};
